import React, {useContext, useEffect, useState} from 'react';
import {Box, Button, Grid, LinearProgress, Link, Tooltip} from "@material-ui/core";
import {EcnhCookie} from "@models/ecnh/EcnhCookie";
import {CookiesBuscarTodos, CookiesExcluir, CookiesForcar} from "@services";
import {DataGrid} from '@material-ui/data-grid';
import {format} from 'date-fns'
import {AuthContext} from "@contexts/AuthContext";

import RefreshIcon from '@material-ui/icons/Refresh';

const EcnhCookies = () => {
    const [cookies, setCookies] = useState<EcnhCookie[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const authContext = useContext(AuthContext);

    useEffect(() => {
        async function init() {
            await buscarCookies();
        }

        init()
    }, []);

    const ExcluirCookie = async (cookieId: number) => {
        setIsLoading(true)
        try {
           var result = await CookiesExcluir(cookieId)

            setCookies(x => [...x.filter(y => y.id !== cookieId)])
            authContext.showAlert('success', `Excluido com sucesso!`, 'Sucesso');

        } catch (e) {
            authContext.showAlert('error', `Erro ao excluir cookieId: ${cookieId}`, 'Erro ao excluir');
            console.error(e);
        } finally {
            setIsLoading(false)

        }
    }
    let columns = [
        {field: 'id', headerName: 'ID', width: 74},
        {field: 'nome', headerName: 'Nome', width: 150},
        {field: 'tipo', headerName: 'Tipo', width: 88},
        {
            field: 'cookie', headerName: 'Cookie',
            flex: 1,
            renderCell: (params: any) => {
                let cookie = (params.row as any)

                return <Tooltip title="Clique para copiar o cookie" aria-label="add">

                    <Link
                        component="button"
                        onClick={() => {
                            navigator.clipboard.writeText(cookie.cookie)
                            authContext.showAlert("success", "Cookie copiado para área de transferência", "Cookie copiado!")
                        }}
                    >
                        {cookie.cookie}
                    </Link></Tooltip>;
            }
        },

        {
            field: 'ultimaAtualizacao', headerName: 'Ultima Atualização', width: 160,
            valueFormatter: (params) => format(new Date(params.value), 'dd/MM/yy HH:mm:ss')
        }
        ,
        {field: 'unidadeId', headerName: 'UnidadeId', width: 120},
        {
            field: 'acao',
            headerName: 'Ações',
            renderCell: (params: any) => {
                let cookie = (params.row as any)

                return <Button color="inherit" disabled={isLoading} onClick={
                    async () => {
                        await ExcluirCookie(cookie.id);
                    }
                }>Excluir</Button>;
            }

        }


    ]

    const buscarCookies = async () => {
        setIsLoading(true);
        try {
            const cook = await CookiesBuscarTodos();
            setCookies(cook);
        }catch (e) {
            authContext.showAlert('error', `Erro ao buscar os cookies`, 'Erro');

        }finally {
            setIsLoading(false);

        }
    }
    const forcarCookie = async () => {
        setIsLoading(true)
        try {
            await CookiesForcar()
            await buscarCookies()
            authContext.showAlert('success', `Todos os cookies foram sincronizados com sucesso!`, 'Sucesso');

        } catch (e) {
            authContext.showAlert('error', `Erro ao forçar cookie`, 'Erro');

        } finally {
            setIsLoading(false)

        }
    }

    return (
        <Grid container spacing={3}>
            <div style={{
                height: '800px',
                minHeight: '400px',
                width: '100%',
                marginBottom: "100px",
                paddingBottom: '100px'
            }}>
                <Box display="flex" flexDirection="row-reverse">
                    <Box m={1}>
                        <Tooltip title="Refresh todos os cookies">

                            <Button
                                variant="contained"
                                color="primary"
                                disabled={isLoading}
                                onClick={async () => {
                                  await  buscarCookies();
                                    authContext.showAlert('success', `Cookies atualizados com sucesso`, 'Sucesso');
                                }}
                            >
                                <RefreshIcon/>
                            </Button>
                        </Tooltip>
                    </Box>
                    <Box m={1}>
                        <Tooltip title="Forçar sincronização de todos os cookies com o ECNH">
                            <Button
                                variant="contained"
                                color="secondary"
                                disabled={isLoading}
                                onClick={() => forcarCookie()}
                            >
                                Forçar atualização cookie
                            </Button>
                        </Tooltip>

                    </Box>

                </Box>

                {(cookies === null || isLoading) && <LinearProgress/>}
                {cookies &&
                <DataGrid getRowId={x => x.id} rows={cookies} columns={columns} rowCount={500} pageSize={100}
                          pagination={true} rowsPerPageOptions={[25, 50, 100]}/>
                }
            </div>
        </Grid>
    );
}

export default EcnhCookies;
